<script setup lang="ts">
import ListBanner from '@components/ui/hotel&view/ListBanner.vue';
import { LoadingStatus } from '@itinerary/ItineraryModuleTypes';
import { ReserveType } from '@utils/itinerary';
import { BannerPositionEnum } from '@clients/ContentApi';
import type SiteBanner from '@store/content/entities/SiteBanner';

const { banner } = defineProps<{
    banner: SiteBanner | null;
}>();

const searchFormStore = useSearchFormStore();
const currentModule = useCurrentItineraryModule();

const gtm = useGtm();
const router = useRouter();

const serviceType = computed(() => {
    switch (banner?.position) {
        case BannerPositionEnum.TaxiBanner:
            return ReserveType.Taxi;

        case BannerPositionEnum.HotelBanner:
            return ReserveType.Hotel;

        default:
            return ReserveType.Taxi;
    }
});

const serviceOption = computed(
    () => searchFormStore.suggestionItems[serviceType.value]
);

const show = computed(
    () =>
        currentModule.value.currentLoadingStatus === LoadingStatus.Success &&
        serviceOption.value
);

const showService = () => {
    gtm?.trackEvent({ event: `${serviceType.value}-offer-card-click` });
    if (!serviceOption.value) {
        return;
    }
    router.replace({
        path: serviceOption.value.viewUrl ?? '',
    });
};
</script>
<template>
    <ListBanner
        v-if="show && banner"
        :key="banner.id"
        class="service-banner"
        :banner
        @click="showService"
    />
</template>

<style lang="scss" scoped>
.service-banner {
    cursor: pointer;
}
</style>
